import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useEMarketplaceLayoutContext } from './EMarketplaceLayoutContext';
import { CommonHelper } from '@ptvn-react/authentication';
import Cookies from 'js-cookie';
import { AlertType, CookieName, GATrackConstant } from '../../utils/constants/CommonConstants';
import { IntegrationClient } from '../../api/IntegrationClient';
import APIConstant from '../../utils/constants/APIConstant';
import { SomethingWentWrongModal } from '../modal/SomethingWentWrongModal';
import GAHelper from '../../utils/helpers/GAHelper';
import { useModalStack } from '../modal/ModalStackProvider';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import PageRoute from '../../utils/constants/PageRoute';

export default function EmarketplaceAlertBar() {

    const { t } = useTranslation();
    const [erfxNo, setErfxNo] = useState<string>();
    const [erfxType, setErfxType] = useState<string>();
    const [isDisplay, setIsDisplay] = useState<boolean>(false);
    const { updateQuotationInfo, role, resetUpdateQuotationInfoOnAlertBar} = useEMarketplaceLayoutContext();
    const { push } = useModalStack();
    const location = useLocation();

    useEffect(() => {
      
        setErfxNo(updateQuotationInfo?.erfxNo);
        setErfxType(updateQuotationInfo?.erfxType?.toUpperCase());

        const isProcurementBoard = (location.pathname.indexOf(PageRoute.JOB_BOARD) >= 0) ? true : false;
        const isValidErfxType = Object.keys(AlertType).find(type => (type == updateQuotationInfo?.erfxType?.toUpperCase()));

        if(updateQuotationInfo?.erfxNo && updateQuotationInfo?.erfxType && !!!isProcurementBoard && isValidErfxType) {
          setIsDisplay(true);
        } else {
          setIsDisplay(false);
        }

    }, [updateQuotationInfo, location.pathname]);


    const getAlertTitleByType = (erfxType: string) => {
        switch(erfxType){
          case AlertType.BLD:
            return t("Layout.AlertBar.BrowsingProductTitle").replace('{ERFX_NO}', erfxNo+'');
          case AlertType.RFQ.toString():
            return t("Layout.AlertBar.BrowsingProductSupplierTitle").replace('{ERFX_NO}', erfxNo+'');  
          case AlertType.RFI.toString():
          case AlertType.RFP.toString():
            return t("Layout.AlertBar.BrowsingSupplierTitle").replace('{ERFX_NO}', erfxNo+'');
          default:
            break;
        }
    }

    const getAlertDescByType = (erfxType: string) => {
      switch(erfxType){
        case AlertType.BLD.toString():
          return t("Layout.AlertBar.BrowsingProductDesc");
        case AlertType.RFI.toString():
        case AlertType.RFP.toString():
          return t("Layout.AlertBar.BrowsingSupplierDesc");
        default:
          return null;
      }
    }
    
    const redirecToERFx = (erfxNo: string) => {

        const tenantID = CommonHelper.base64Decoder(Cookies.get(CookieName.TENANT_ENTITY) || "");
        IntegrationClient.getAuthCode(tenantID).subscribe(
          (res) => { 
            if(res) {
              const url = APIConstant.erfx.proceedToERFX.replace('{res.data.authCode}', res.data.authCode).replace('{erfxNo}', erfxNo.toString());
              resetUpdateQuotationInfoOnAlertBar();
              window.location.assign(url);

            }},
          (err) => {
            console.error("unable to get UAA Auth Code.", err);
            push(SomethingWentWrongModal, {
              onSubmit: () => { 
                redirecToERFx(erfxNo);
                GAHelper.eventWithRole(role, GATrackConstant.Unprocessable);
              },
            });
          }
        );
    };

    const alerDesc = getAlertDescByType(erfxType+'');
    return (
        <>
        {   (isDisplay && isDisplay === true) &&
            <div className="alert alert-default alert-fixed">
                <div className={`media ${alerDesc ? '' : 'p-1'}`}>
                    <div className="float-left"><i className="icon-eye-open color-primary"></i></div>
                    <div className="media-body">
                    <p>{ getAlertTitleByType(erfxType+'') } <small>{ alerDesc }</small></p>
                    </div>
                </div>
                
                <div className="ml-auto p-1">
                    <Link to="#" onClick={() => redirecToERFx(erfxNo+'')} className="btn-link nowrap">{ t("Layout.AlertBar.BackToErfxTextLink") }</Link>
                </div>
            </div>
         }
        </>
    )
}
